/**
 * Which images get the large tile in a photo wall mosaic.
 *
 * The wall is laid out in blocks of five — one large tile plus four standard ones — and the large
 * one alternates between the start and the middle of the block, so the eye is pulled left, then
 * right, down the page. A standard tile covers 3x2 grid cells and a large one 6x4, so either
 * arrangement fills exactly 12 columns by 4 rows and the grid never leaves a hole.
 *
 * A trailing block with fewer than five images is left all-standard: a large tile there would have
 * nothing to pack around it.
 */
export function isLarge(index: number, total: number): boolean {
  const block = Math.floor(index / 5);
  const isTruncatedBlock = total - block * 5 < 5;
  if (isTruncatedBlock) return false;
  return index % 5 === (block % 2 === 0 ? 0 : 2);
}
